import { Spacing } from '@persona-id/design-tokens';
import { BORDER_RADIUSES } from 'shared/styles/variables';
import styled from 'styled-components';

import ModalWrapper from 'dashboard/components/ModalWrapper';
import Permissioned from 'dashboard/components/Permissioned';
import FormUpdateTags, { FormUpdateTagsData } from 'dashboard/forms/FormUpdateTags';
import { ModalBody, ModalContainer, ModalHeader } from 'dashboard/layouts/ModalLayout';
import { Tag, TagScope } from 'dashboard/models/tag';
import Attribute from 'design-system/components/Attribute';
import Button from 'design-system/components/Button';
import Sticker from 'design-system/components/Sticker';
import useToggle from 'lib/hooks/useToggle';
import { Permission } from 'lib/permissions';

const TagStickerContainer = styled('div')`
  margin-right: ${Spacing[4]};
`;

const ButtonContainer = styled('div')`
  display: flex;
  align-items: center;
  box-sizing: border-box;
`;

const StyledButton = styled(Button)`
  border-radius: ${BORDER_RADIUSES.pill};
  padding: 4px 8px;
  height: auto;
`;

const TagsContainer = styled('div')`
  display: flex;
  align-items: center;
`;

interface ResourceTagsProps {
  tags: Tag[];
  tagScope: TagScope;
  editTagPermission: Permission;
  onUpdateTags: (tags: string[]) => void;
}

const ResourceTags = ({ tags, tagScope, editTagPermission, onUpdateTags }: ResourceTagsProps) => {
  const [updateTagsModal, { enable: openUpdateTagsModal, disable: hideUpdateTagsModal }] =
    useToggle(false);

  const handleUpdateTagsAndClose = ({ tags }: FormUpdateTagsData) => {
    onUpdateTags(tags);
    hideUpdateTagsModal();
  };

  return (
    <>
      <Attribute label='Tags' placeholder='' />
      <TagsContainer>
        {tags.map((tag) => (
          <TagStickerContainer key={tag.id}>
            <Sticker>{tag.attributes.name}</Sticker>
          </TagStickerContainer>
        ))}
        <Permissioned permission={editTagPermission}>
          {tags.length > 0 && (
            <ButtonContainer>
              <StyledButton variant='basic' onClick={openUpdateTagsModal} size='sm'>
                <p>Edit Tags</p>
              </StyledButton>
            </ButtonContainer>
          )}
          {tags.length === 0 && (
            <ButtonContainer>
              <StyledButton variant='basic' onClick={openUpdateTagsModal} size='sm'>
                <p>Click to add tag</p>
              </StyledButton>
            </ButtonContainer>
          )}
        </Permissioned>
      </TagsContainer>
      <ModalWrapper isOpen={updateTagsModal} handleCloseModal={hideUpdateTagsModal}>
        <ModalContainer>
          <ModalHeader onClose={hideUpdateTagsModal}>Update tags</ModalHeader>
          <ModalBody>
            <FormUpdateTags
              initialValues={{ tags: tags?.map((t) => t.id) ?? [] }}
              onSubmit={handleUpdateTagsAndClose}
              handleCancel={hideUpdateTagsModal}
              tagScope={tagScope}
            />
          </ModalBody>
        </ModalContainer>
      </ModalWrapper>
    </>
  );
};

export default ResourceTags;
